module.exports = __webpack_public_path__ + "img/ic_room_store_bottom_item_img1.5af5191c.png";